
<div class="content-wrapper pt-2"> 
  <section class="content">
   
    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">Expense</div> 
      <form [formGroup]="expenseForm"  autocomplete="off"  class="form-horizontal">   
      <div class="card-body">   
          
        <div class="row">    
          <div class="col-md-3">
            <div class="form-group">
              <label for="expNo" class="col-form-label">Expense No</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
                </div>
                <input type="text" readonly [ngClass]="{'dark-input-field' : isDark }" formControlName="expNo" class="form-control field-bg-color" [class.is-invalid]="formErrors.expNo" (blur)="logValidationErrors()" placeholder="Exp No">
              </div>
              <span class="text-danger" *ngIf="formErrors.expNo"><small>{{formErrors.expNo}}</small> </span>   
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="expDate" class="col-form-label">Expense Date </label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="expDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.expDate" (blur)="logValidationErrors()" placeholder="Exp Date">
              </div>
              <span class="text-danger" *ngIf="formErrors.expDate"><small>{{formErrors.expDate}}</small> </span>   
            </div>
          </div> 
          <div class="form-group">
            <input  name="supId" readonly formControlName="supId" class="form-control"    type="hidden">
            </div>           
            <div class="col-md-5">
              <div class="form-group">
                <label for="supName" class="col-form-label">Supplier</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
                  </div>
                  <input [ngClass]="{'dark-input-field' : isDark }" type="text" formControlName="supName" (focusout)="getSupplierDetails()"  [matAutocomplete]="autoSupplier" class="form-control field-bg-color"  [class.is-invalid]="formErrors.supName" (blur)="logValidationErrors()" placeholder="Supplier Name">
                  <mat-autocomplete autoActiveFirstOption  #autoSupplier="matAutocomplete">
                    <mat-option *ngFor="let option of filteredSupplierList | async" [value]="option.SupName">
                      {{option.SupName}}
                    </mat-option>
                  </mat-autocomplete>                
                </div>
                <span class="text-danger" *ngIf="formErrors.supName"><small>{{formErrors.supName}}</small> </span>               
              </div>
            </div>          
        </div>

        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="status" class="col-form-label">Status</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                </div>
                <select [ngClass]="{'dark-input-field' : isDark }" (change)="changeStatus($event.target)" formControlName="status" class="form-control field-bg-color" [class.is-invalid]="formErrors.status" (blur)="logValidationErrors()">        
                  <option [ngValue]="null">-Select-</option>
                  <option *ngFor="let item of STATUS" [value]="item.value">
                    {{item.value}}
                  </option>
              </select>
              </div>
              <span class="text-danger" *ngIf="formErrors.status"><small>{{formErrors.status}}</small> </span>   
            </div>
          </div>   

          <div class="col-md-3" *ngIf="isShowPaymentFields">          
            <div class="form-group">
              <label for="paymentType" class="col-form-label">Payment Type</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                </div>
                <select [ngClass]="{'dark-input-field' : isDark }" formControlName="paymentType" class="form-control field-bg-color">        
                  <option [ngValue]="null">-Select-</option>
                  <option *ngFor="let item of PMT_TYPE" [value]="item.value">
                    {{item.value}}
                  </option>
              </select>
              </div>
            </div>
          </div>

          <div class="col-md-3" *ngIf="isShowPaymentFields">
            <div class="form-group">
              <label for="paymentAccount" class="col-form-label">Payment Account</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                </div>
                <select [ngClass]="{'dark-input-field' : isDark }" formControlName="paymentAccount" class="form-control field-bg-color">        
                  <option [ngValue]="null">-Select-</option>
                  <option *ngFor="let item of bankAccountList" [value]="item.AccountName">
                    {{item.AccountName}}
                  </option>
              </select>
              </div>
            </div>
          </div>

          <div class="col-md-3" *ngIf="isShowPaymentFields">
            <div class="form-group">
              <label for="paymentRefNo" class="col-form-label">Payment Ref No.</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-edit"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }"  formControlName="paymentRefNo" class="form-control field-bg-color"  placeholder="Payment Ref No.">
              </div>
            </div>
          </div>
        </div>

     

        <!-- Purchase Orer Items -->   
        <div class="row"> 
        <div class="col-md-12">
        <table class="table table-sm mt-2 table-bordered" [ngClass]="{'dark-bg' : isDark }">  
          <thead class="thead-light" [ngClass]="{'dark-input-field' : isDark }" [ngClass]="{'thead-light' : !isDark }">
              <tr>
                <th scope="col">Expense</th>
                <th scope="col">Category</th>               
                <th scope="col">Remarks</th>
                <th scope="col" style="text-align: center">Amount</th>
                <th *ngIf="!isHideBtn"></th> 
              </tr>
            </thead>

            <tbody class="ml-1" formArrayName="expItems" *ngFor="let invoiceItem of expenseForm.get('expItems')['controls']; let i = index">                    
                  <tr [formGroupName] = "i" >                      
                      <td>
                        <input [ngClass]="{'dark-input-field' : isDark }" type="text"  #inputFocus  [class.is-invalid]="invoiceItem.get('expName').invalid && invoiceItem.get('expName').touched"  [matAutocomplete]="auto" class="form-control form-control-sm field-bg-color" formControlName="expName">
                        <mat-autocomplete autoActiveFirstOption  #auto="matAutocomplete">
                          <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option.ExpName">
                            {{option.ExpName}}
                          </mat-option>
                        </mat-autocomplete>   
                      </td>                   
                      <td>
                        <select [ngClass]="{'dark-input-field' : isDark }" type="text" [class.is-invalid]="invoiceItem.get('expCategory').invalid && invoiceItem.get('expCategory').touched" class="form-control form-control-sm field-bg-color" formControlName="expCategory">
                          <option [ngValue]="null">-Select-</option>
                          <option *ngFor="let item of EXP_TYPES" [value]="item.value">  {{item.value}} </option>    
                          </select>       
                      </td>  
                      <td><input [ngClass]="{'dark-input-field' : isDark }" type="text" class="form-control form-control-sm field-bg-color" formControlName="remarks"></td>  
                      <td><input [ngClass]="{'dark-input-field' : isDark }" type="text" style="text-align: right" [class.is-invalid]="invoiceItem.get('amount').invalid && invoiceItem.get('amount').touched"  (keyup)="updateBillTotal()" (focusout)="updateBillTotal()"  class="form-control form-control-sm field-bg-color" formControlName="amount"></td>  
                      <td *ngIf="!isHideBtn">
                          <button *ngIf="!isBtnDisabled && expenseForm.get('expItems').length > 1" class="btn btn-danger btn-sm ml-1 text-white" (click)="removeItemButtonClick(i)" data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="fa fa-close"></i></button>         
                      </td>                    
                    </tr> 
                                                                          
            </tbody>
            <tfoot *ngIf="!isHideBtn">
              <tr>
                <td colspan="5"><button  [disabled]="isBtnDisabled || expenseForm.get('expItems').invalid" type="button" class="btn btn-success btn-sm text-white float-right" (click)="addItemButtonClick()"><i class="fa fa-plus"></i> Add</button></td>
              </tr>   
            </tfoot>
        </table> 
      </div> 
    </div>

      <div class="row mt-3 mr-4">     
          <div class="col-md-4 offset-md-8">
            <table class="table table-clear" [ngClass]="{'dark-bg' : isDark }">
              <tbody>
              <tr>
              <td class="left"><strong>Total</strong></td>                             
              <td class="text-right"><strong>{{expense.expTotal |  number:'1.2-2'}}</strong></td>
              </tr>       
              </tbody>
              </table>
        </div>
      </div>

    
      </div>
      
      <!-- /.card-body -->
        
      <div class="card-footer">
      <button  *ngIf="crud_access.create"  type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>
        <button  *ngIf="crud_access.create && isShowSaveBtn"   type="button"  (click)="saveButtonClick()" class="btn btn-info ml-2">
         <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          Save
        </button>
        <button type="button" class="btn btn-success ml-2" routerLink="../expense-list"><i class="fa fa-table p-1"></i>Expense List</button>
        <button type="button"  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        
      </div>

      </form>
    </div>
    <!-- Form Values : {{ expenseForm.value | json }}    -->
  </section>

</div> 



